<template>
  <div class="dashboard-root">
    <!-- HERO -->
    <section class="hero">
      <div class="hero-bg-icon">💬</div>

      <div class="hero-content">
        <div class="hero-badge">
          <span class="hero-badge-icon">🏅</span>
          <span>Marca Registrada</span>
        </div>

        <h2 class="hero-title">
          O feedback é a nossa ponte para a excelência.
        </h2>

        <p class="hero-subtitle">
          Não apenas processamos informações; cultivamos o crescimento contínuo.
          Sua voz importa e sua escuta transforma.
        </p>

        <div class="hero-actions">
          <button
            type="button"
            class="btn-primary"
            @click="$emit('go-to-values')"
          >
            Explorar Cultura →
          </button>

          <button
            type="button"
            class="btn-secondary"
            @click="$emit('open-manifesto')"
          >
            📄 Ler Manifesto
          </button>
        </div>
      </div>
    </section>

    <!-- LEMBRETE DIÁRIO -->
    <section class="card">
      <div class="card-header">
        <h3 class="card-title">⚡ Lembrete Diário</h3>
        <button
          type="button"
          class="icon-btn"
          title="Novo lembrete"
          @click="$emit('refresh-quote')"
        >
          🔄
        </button>
      </div>

      <blockquote class="daily-quote">“{{ dailyQuote }}”</blockquote>
    </section>

    <!-- GRÁFICOS -->
    <section class="charts-grid">
      <!-- Radar -->
      <div class="card">
        <h3 class="card-title">Bússola de Competências</h3>
        <p class="card-subtitle">O equilíbrio entre técnica e humildade.</p>

        <div class="chart-container">
          <apexchart
            type="radar"
            height="260"
            :options="radarOptions"
            :series="radarSeries"
          />
        </div>
      </div>

      <!-- Bar -->
      <div class="card">
        <h3 class="card-title">Dinâmica de Feedback</h3>
        <p class="card-subtitle">
          Dar construtivamente vs. Receber com motivação.
        </p>

        <div class="chart-container">
          <apexchart
            type="bar"
            height="260"
            :options="barOptions"
            :series="barSeries"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'CulturaDashboard',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    dailyQuote: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      radarSeries: [
        {
          name: 'Perfil Ideal eSUS',
          data: [90, 90, 90, 90, 90],
        },
      ],
      radarOptions: {
        chart: {
          toolbar: { show: false },
        },
        labels: [
          'Monitoramento',
          'Avaliação',
          'Humildade',
          'Ensino',
          'Aprendizado',
        ],
        yaxis: {
          show: false,
          min: 0,
          max: 100,
        },
        xaxis: {
          labels: {
            style: {
              colors: '#64748b',
              fontSize: '12px',
            },
          },
        },
        stroke: {
          width: 2,
        },
        fill: {
          opacity: 0.3,
        },
      },
      barSeries: [
        {
          name: 'Impacto na Excelência',
          data: [90, 95],
        },
      ],
      barOptions: {
        chart: {
          toolbar: { show: false },
        },
        xaxis: {
          categories: ['Dar Feedback', 'Receber Feedback'],
          labels: {
            style: {
              colors: '#64748b',
              fontSize: '12px',
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          // tickAmount: 4, // 0 / 25 / 50 / 75 / 100
          labels: {
            style: {
              colors: '#64748b',
              fontSize: '11px',
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#22c55e', '#3b82f6'],
        grid: {
          yaxis: {
            lines: { show: false },
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 6,
            columnWidth: '50%',
          },
        },
      },
    }
  },
}
</script>

<style scoped>
.dashboard-root {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* HERO */

.hero {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  padding: 24px;
  background: linear-gradient(90deg, #2563eb, #06b6d4);
  color: #ffffff;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.3);
}

.hero-bg-icon {
  position: absolute;
  top: -10px;
  right: 16px;
  opacity: 0.12;
  font-size: 72px;
}

.hero-content {
  position: relative;
  max-width: 540px;
  z-index: 1;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  margin-bottom: 12px;
}

.hero-badge-icon {
  font-size: 14px;
}

.hero-title {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
}

.hero-subtitle {
  font-size: 15px;
  color: #e0f2fe;
  margin-bottom: 16px;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

/* BOTÕES */

.btn-primary,
.btn-secondary {
  border-radius: 10px;
  padding: 8px 16px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
}

.btn-primary {
  background: #ffffff;
  color: #2563eb;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.35);
}

.btn-primary:hover {
  background: #eff6ff;
}

.btn-secondary {
  background: rgba(15, 23, 42, 0.4);
  color: #ffffff;
  border: 1px solid rgba(248, 250, 252, 0.5);
}

.btn-secondary:hover {
  background: rgba(15, 23, 42, 0.55);
}

/* CARDS GENÉRICOS */

.card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 16px 18px 18px;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.02);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.card-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 4px;
  margin-bottom: 10px;
}

.icon-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
}

.daily-quote {
  border-left: 4px solid #facc15;
  padding-left: 12px;
  margin: 0;
  font-size: 16px;
  color: #475569;
  font-style: italic;
}

/* GRIDS E CHARTS */

.charts-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.chart-container {
  margin-top: 8px;
}

/* Desktop */
@media (min-width: 768px) {
  .hero {
    padding: 32px;
  }

  .hero-title {
    font-size: 30px;
  }

  .charts-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
